import { render, staticRenderFns } from "./AllConsent.vue?vue&type=template&id=2a042ae2&scoped=true&"
import script from "./AllConsent.vue?vue&type=script&lang=js&"
export * from "./AllConsent.vue?vue&type=script&lang=js&"
import style0 from "./AllConsent.vue?vue&type=style&index=0&id=2a042ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a042ae2",
  null
  
)

export default component.exports